
import { throwError as observableThrowError, Subject } from 'rxjs';

import { catchError, tap, finalize } from 'rxjs/operators';

import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Router } from '@angular/router';
import { GenericResponse } from '@otas/model/genericResponse';
import { ToasterService } from './toaster.service';
import { AppConstants } from '../app.constants';
import { UtilService } from './util.service';
import { GlobalData } from '../globalData';
import * as _ from 'underscore';
import { environment } from 'environments/environment';
import { ProgressBarService } from '@otas/shared/progress-bar/progress-bar.service';
@Injectable()
export class NotificationInterceptor implements HttpInterceptor {
  detailsSubject = new Subject<any>();
  /**
   * R48: while the server is down EVERY in-flight request fails with status 0,
   * and this interceptor used to toast "Server Not Responding" once PER
   * REQUEST (the login screen showed two at once). One intimation per window
   * is enough - the login page carries its own server-status panel now.
   */
  private lastServerDownToastAt = 0;

  constructor(public toastr: ToasterService, private router: Router, private progressBarService: ProgressBarService, private utilService: UtilService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return !next.handle(req) ? this.detailsSubject : next.handle(req).pipe(finalize(() => {

    }),
      tap(event => {
        this.utilService.buttonDisableObservable.next(false);
        if (event instanceof HttpResponse) {
        this.progressBarService.display(false);
        const response = <GenericResponse<any>>event.body;
          if (!!response) {
            const currentApi = _.find(GlobalData.menus, menu => event.url.includes(menu.api));
            if (response.status === 'FAILED' && !!response.message) {
              this.toastr.error(response.message);
            } else if (response.status === 'FAILED') {
              this.toastr.error(`Failed to get a valid response for ${response.operationCode}`);
            }
            if (response.status === 'SUCCESS' && response.result?.type === "devotee_name_suggesion") {
              if (response.result?.value === "true") {
                this.toastr.success(`Devotee Name Auto Suggestion ON`);
              }
              if (response.status === 'SUCCESS' && response.result?.value === "false") {
                this.toastr.success(`Devotee Name Auto Suggestion OFF`);
              }
            }
            if (response.status === 'SUCCESS' && response.result?.type === "pooja_suggesion") {
              if (response.result?.value === "true") {
                this.toastr.success(`Pooja Auto Suggestion ON`);
              }
              if (response.status === 'SUCCESS' && response.result?.value === "false") {
                this.toastr.success(`Pooja Auto Suggestion OFF`);
              }
            }
            if (response.status === 'SUCCESS' && response.result?.type === "old_pooja_date_billing") {
              if (response.result?.value === "true") {
                this.toastr.success(`Old Pooja Date Billing ON`);
              }
              if (response.status === 'SUCCESS' && response.result?.value === "false") {
                this.toastr.success(`Old Pooja Date Billing OFF`);
              }
            }
            if (response.status === 'SUCCESS' && response.result?.type === "isStockInventory") {
              if (response.result?.value === "true") {
                this.toastr.success(`Stock and Inventory Enabled`);
              }
              if (response.status === 'SUCCESS' && response.result?.value === "false") {
                this.toastr.success(`Stock and Inventory Disabled`);
              }
            }
            if (response.status === 'SUCCESS' && response.result?.type === "isPoojaAccountChange") {
              if (response.result?.value === "true") {
                this.toastr.success(`Pooja Account Change Enabled`);
              }
              if (response.status === 'SUCCESS' && response.result?.value === "false") {
                this.toastr.success(`Pooja Account Change Disabled`);
              }
            }
            if (response.status === 'SUCCESS' && response.result?.type !== "devotee_name_suggesion" &&
            response.result?.type !== "pooja_suggesion" && response.result?.type !== "old_pooja_date_billing" &&
            response.result?.type !== "isStockInventory" &&
              (response.operationCode.startsWith('CREATE') || response.operationCode.startsWith('REMOVE') ||
                response.operationCode.startsWith('EDIT') || response.operationCode.startsWith('UPDATE') ||
                response.operationCode.startsWith('ADD') ||
                response.operationCode.startsWith('DELETE'))) {
              this.toastr.success(response.message, 'Success!');
            }
            else if (response.status === 'SUCCESS' &&
              response.operationCode.startsWith('GET')) {
              if (!!currentApi && !currentApi.array.length) {
                currentApi.array = response.result;
                // console.log(`setting data for ${currentApi.api}`);
              }
            }
          }
          // if ( event.status === 201 && event.type ) {
          //     this.toastr.error('Session expired, Please sign in.');
          // }

        }

      }),
      // tslint:disable-next-line:no-shadowed-variable
      catchError((error: any, caught: Observable<any>): Observable<any> => {
        // this.utilService.buttonDisableObservable.next(false);
        // this.progressBarService.display(true);
        if (error instanceof HttpErrorResponse && error.status === 401) {
          this.toastr.error('Session expired, Please sign in.');
          sessionStorage.clear();
          this.router.navigate(['/error']);
          return observableThrowError(error);
        }
        if (error instanceof HttpErrorResponse && error.status === 403) {
          this.toastr.error('You do not have sufficient permission to do this action.');
          return observableThrowError(error);
        }
        if (error instanceof HttpErrorResponse && error.message === 'Http failure response for (unknown url): 0 Unknown Error') {

          if (error.status === 0) {
            sessionStorage.clear();
            this.router.navigate(['/error']);

          } else {
            this.toastr.error('Please Login ', 'INVALID_TOKEN !!');
            sessionStorage.clear();
            this.router.navigate(['/error']);
          }
        }
        if (error instanceof HttpErrorResponse && error.message.includes(`Http failure response for ${error.url}: 0 Unknown Error`)) {
          if (error.url === environment.apiUrl) {
            this.progressBarService.display(true);
          } else if (Date.now() - this.lastServerDownToastAt > 8000) {
            this.lastServerDownToastAt = Date.now();
            this.toastr.error('Server Not Responding ', 'Oops!!');
          }
        }

        return observableThrowError(error);
      }));
  }
}
